import React from 'react';
import Layout from 'src/components/empty.layout';
import LandingPage from 'src/components/landingpage/landingpage';

export default function Document(): any {
  return (
    <Layout
      title="Domain API | Property Data API | Real Estate Data API Australia"
      description="The Domain API provides access to agency, listing and Australian property data from Domain Group. You can sign-up and create your Developer account using your GitHub or Google account."
    >
      <LandingPage />
    </Layout>
  );
}
